import { createContext } from "react";
import { LayoutContextType, LayoutActions } from "./LayoutContextTypes";

export const LayoutContext = createContext<[LayoutContextType, (action: LayoutActions) => void] | undefined>(undefined);
